module.exports = __webpack_public_path__ + "assets/img/icon-yinyue-663a74cc.png";